import { render } from "./CanalesVentas.vue?vue&type=template&id=540c05f3"
import script from "./CanalesVentas.vue?vue&type=script&lang=js"
export * from "./CanalesVentas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__